import Vue from "vue";
import Vuex from "vuex";
import http, { attachAuthInterceptor } from "./http";

Vue.use(Vuex);

// Хранилище для интервалов, чтобы их можно было очистить
const intervals = {
  freeSpace: null,
  userData: null,
  library: null
};

export const store = new Vuex.Store({
  state: {
    wait: false,
    resultSearch: [],
    resultText: "",
    freeSpace: 0,
    userData: {
      limit: [0, 0],
      rt: 0,
    },
    library: {},
    auth: localStorage.getItem("auth") === "true",
  },
  getters: {
    freeSpace: (state) => state.freeSpace,
    userData: (state) => state.userData,
    library: (state) => state.library,
    auth: (state) => state.auth,
    resultSearch: (state) => state.resultSearch,
    resultText: (state) => state.resultText,
  },
  mutations: {
    // Мутации должны быть синхронными - только обновление state
    SET_FREE_SPACE(state, payload) {
      state.freeSpace = payload;
    },
    SET_USER_DATA(state, payload) {
      state.userData = payload;
    },
    SET_LIBRARY(state, payload) {
      state.library = payload;
    },
    UPDATE_AUTH(state, payload) {
      localStorage.setItem("auth", payload);
      state.auth = payload;
    },
    SET_RESULT_SEARCH(state, payload) {
      state.resultSearch = payload;
    },
    SET_RESULT_TEXT(state, payload) {
      state.resultText = payload;
    },
  },
  actions: {
    // Actions выполняют async операции и вызывают mutations
    async fetchFreeSpace({ commit }) {
      if (!localStorage.getItem('jwt')) {
        return;
      }
      try {
        const resp = await http.get("/getFreeSpace");
        commit("SET_FREE_SPACE", resp.data);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Ошибка при получении свободного места:', error);
        }
      }
    },
    async fetchUserData({ commit }) {
      if (!localStorage.getItem('jwt')) {
        return;
      }
      try {
        const resp = await http.get("/getUserData");
        const userData = {
          limit: [0, 0],
          rt: 0
        };
        if (resp.data.limit != undefined) {
          userData.limit = resp.data.limit
            .match(/(-?\d+(\.\d+)?)/g)
            .map((v) => +v);
        }
        userData.rt = resp.data.rt;
        commit("SET_USER_DATA", userData);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Ошибка при получении данных пользователя:', error);
        }
      }
    },
    async fetchLibrary({ commit }) {
      if (!localStorage.getItem('jwt')) {
        return;
      }
      try {
        const resp = await http.get("/getLibrary");
        commit("SET_LIBRARY", resp.data.reverse());
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Ошибка при получении библиотеки:', error);
        }
      }
    },
    // Инициализация с периодическим обновлением
    getFreeSpace({ dispatch }) {
      // Очищаем предыдущий интервал если есть
      if (intervals.freeSpace) {
        clearInterval(intervals.freeSpace);
      }
      // Выполняем сразу
      dispatch('fetchFreeSpace');
      // Устанавливаем интервал
      intervals.freeSpace = setInterval(() => {
        dispatch('fetchFreeSpace');
      }, 1200000); // 20 минут
    },
    getUserData({ dispatch }) {
      // Очищаем предыдущий интервал если есть
      if (intervals.userData) {
        clearInterval(intervals.userData);
      }
      // Выполняем сразу
      dispatch('fetchUserData');
      // Устанавливаем интервал
      intervals.userData = setInterval(() => {
        dispatch('fetchUserData');
      }, 600000); // 10 минут
    },
    getLibrary({ dispatch }) {
      // Очищаем предыдущий интервал если есть
      if (intervals.library) {
        clearInterval(intervals.library);
      }
      // Выполняем сразу
      dispatch('fetchLibrary');
      // Устанавливаем интервал
      intervals.library = setInterval(() => {
        dispatch('fetchLibrary');
      }, 1200000); // 20 минут
    },
    // Очистка всех интервалов (вызывать при выходе)
    clearIntervals() {
      if (intervals.freeSpace) {
        clearInterval(intervals.freeSpace);
        intervals.freeSpace = null;
      }
      if (intervals.userData) {
        clearInterval(intervals.userData);
        intervals.userData = null;
      }
      if (intervals.library) {
        clearInterval(intervals.library);
        intervals.library = null;
      }
    },
    async updateToken({ commit, dispatch }) {
      if (localStorage.getItem("user") && localStorage.getItem("jwt")) {
        try {
          await http.post("/checkToken", {
            name: JSON.parse(localStorage.getItem("user")).name,
            token: localStorage.getItem("jwt"),
          });
        } catch (error) {
          const status = error.response && error.response.status;
          if (status === 401 || status === 403) {
            commit("UPDATE_AUTH", false);
            dispatch("clearIntervals");
            localStorage.removeItem("user");
            localStorage.removeItem("auth");
            localStorage.removeItem("jwt");
          } else if (process.env.NODE_ENV !== "production") {
            console.error("Ошибка при проверке токена:", error);
          }
        }
      } else {
        commit("UPDATE_AUTH", false);
        localStorage.removeItem("auth");
        localStorage.removeItem("jwt");
        localStorage.removeItem("user");
      }
    },
  },
});

attachAuthInterceptor(store);
